import { render, staticRenderFns } from "./BrazilStatesMap.vue?vue&type=template&id=ba9acd96&scoped=true"
import script from "./BrazilStatesMap.vue?vue&type=script&lang=js"
export * from "./BrazilStatesMap.vue?vue&type=script&lang=js"
import style0 from "./BrazilStatesMap.vue?vue&type=style&index=0&id=ba9acd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9acd96",
  null
  
)

export default component.exports